import { fields } from './specialistHelpers';
import { untouch, touch } from 'redux-form';

export * from './specialistHelpers';
export const LOAD_CONTENT = 'hg/specialist/LOAD_CONTENT';
export const SUBMIT_ORDER = 'hg/specialist/SUBMIT_ORDER';
export const DL_PAGE_LOADED = 'hg/specialist/DL_PAGE_LOADED';

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};

export const submitOrder = () => {
  return {
    type: SUBMIT_ORDER
  };
};

export const touchFields = () => {
  return (dispatch) => {
    dispatch(untouch('specialist', ...fields));
    dispatch(touch('specialist', ...fields));
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/Movers/specialist/specialist.js
 **/